export default __webpack_public_path__ + "static/media/graduation-cap.d031c245.png";